import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-af1d7cf2")

_pushScopeId("data-v-af1d7cf2")
const _hoisted_1 = { id: "hot" }
const _hoisted_2 = { class: "mt-16 mb-8" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.topics, (item, index) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          key: index,
          to: `/topic/${item.label}`,
          custom: ""
        }, {
          default: _withId(({navigate}) => [
            _createVNode("span", {
              class: "mr-8 c-primary br-lg hot-item f-md",
              onClick: navigate
            }, "#" + _toDisplayString(item.label), 9, ["onClick"])
          ]),
          _: 2
        }, 1032, ["to"]))
      }), 128))
    ])
  ]))
})